module.exports = __webpack_public_path__ + "static/media/testomonialimg2.7ca6c6a4.webp";